// extracted by mini-css-extract-plugin
module.exports = {"images":"Images_images__3-Hp5","expand":"Images_expand__1w8-F"};